import Vue from "vue";
import Router, { useRouter } from "vue-router";
import Home from "./views/Home.vue";
import OrderSuccess from "./views/OrderSuccess.vue";
import OrderList from "./views/OrderList.vue";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import PayWall from "./views/PayWall.vue";
import store from "./store";
import Dues from "./views/Dues.vue";
import PendingOrdersList from "./views/PendingOrdersList.vue";
import PendingOrders from "./views/PendingOrders.vue";
import PendingOrdersCsv from "./views/PendingOrdersCsv.vue";
import Employee from "./views/Employee.vue";
import { OrderStore } from "./OrderStore";

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    linkActiveClass: "active",
    routes: [
        {
            path: "/",
            exact: true,
            name: "root",
            component: Home,
            meta: { requiresAuth: true },
        },
        {
            path: "/home",
            name: "home",
            component: Home,
            meta: { requiresAuth: true },
        },
        {
            path: "/employee",
            name: "employee",
            component: Employee,
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (OrderStore.Amount <= 0.0) {
                    next("/");
                }

                next();
            },
        },
        {
            path: "/orders",
            name: "orders",
            component: OrderList,
            meta: { requiresAuth: true },
        },
        {
            path: "/order-success",
            name: "orderSuccess",
            component: OrderSuccess,
            meta: { requiresAuth: true },
        },
        {
            path: "/signin",
            name: "signin",
            component: Login,
        },
        {
            path: "/dashboard",
            name: "dashboard",
            component: Dashboard,
        },
        {
            path: "/pay-wall",
            name: "pay-wall",
            component: PayWall,
        },
        {
            path: "/dues",
            name: "dues",
            component: Dues,
            meta: { requiresAuth: true },
        },
        {
            path: "/pending-orders",
            name: "pending-orders",
            component: PendingOrdersList,
            meta: { requiresAuth: true },
        },
        {
            path: "/pending-orders/add",
            name: "pending-orders-add",
            component: PendingOrders,
            meta: { requiresAuth: true },
        },
        {
            path: "/pending-orders/add-csv",
            name: "pending-orders-add-csv",
            component: PendingOrdersCsv,
            meta: { requiresAuth: true },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!localCurrentUser()) {
            next({
                path: "/signin",
            });
        }

        next();
    } else {
        next();
    }
});

function localCurrentUser() {
    if (localStorage.getItem("cashWalletToken")) {
        store.dispatch(
            "setUser",
            JSON.parse(localStorage.getItem("cashWalletToken"))
        );
    }
    return store.state.user;
}

export default router;
